module.exports = __webpack_public_path__ + "static/Lisa-89d60f6e5421da06f229f2ffdaea4900.jpg";